// extracted by mini-css-extract-plugin
module.exports = {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__BL6Ri","player":"MediaSideBar_player__1vCwc"};